import { VisibilitySettings } from '@front-app/services/GroupsApi/GroupModel';
import { updateVisibilitySettings } from '@front-app/services/GroupsApi/GroupsAdmin';
import { Singleton } from '@front-app/util/interface';
import { defineStore } from 'pinia';
import { GroupsStore } from '../modules/groups';
import { GroupsStore as GlobalGroupsStore } from '../singletons/Groups';

interface GroupVisibilityStoreDependencies {
	groupsStore: Singleton<GroupsStore>;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createGroupVisibilityStore = (name: string, dependencies: GroupVisibilityStoreDependencies) => defineStore(name, {
	actions: {
		async updateSettings(groupId: string, newSettings: VisibilitySettings) {
			const visibilitySettings = await updateVisibilitySettings(newSettings, groupId);
			dependencies.groupsStore
				.getInstance()
				.updateLocalGroup(groupId, { visibilitySettings });
		},
	},
});

export const useGroupVisibilityStore = createGroupVisibilityStore('groupVisibility', {
	groupsStore: GlobalGroupsStore,
});
